const Remote = () => {
    return (
        <h1> I m setting page . coming soon</h1>
    );
}

export default Remote